import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "fieldset"];

  connect() {
    this.#toggleHelper(this.inputTarget);
  }

  toggle(event) {
    this.#toggleHelper(event.target);
  }

  #toggleHelper(input) {
    if (input.value.trim().length) {
      this.#enableFieldset();
    } else {
      this.#disableFieldset();
    }
  }

  #enableFieldset() {
    this.fieldsetTarget.disabled = false;
  }

  #disableFieldset() {
    this.#resetFieldsetInputs();
    this.fieldsetTarget.disabled = true;
  }

  #resetFieldsetInputs() {
    this.#fieldsetInputs.forEach(function(input) {
      if (input.nodeName === 'INPUT' && input.type === 'checkbox') {
        input.checked = false;
      }
    });
  }

  get #fieldsetInputs() {
    return this.fieldsetTarget.querySelectorAll('input[type=checkbox]');
  }
}
